import { render } from "./EditPage.vue?vue&type=template&id=3ff10a3e"
import script from "./EditPage.vue?vue&type=script&lang=js"
export * from "./EditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__